import omit from 'lodash/omit';
import keys from 'lodash/keys';

const emptyValues = ['', undefined, NaN];
export const omitEmpty = (form, extraEmptyValues) => {
  const nextEmptyValues = emptyValues.concat(extraEmptyValues);
  const emptyKeys = keys(form).filter((key) => nextEmptyValues.indexOf(form[key]) !== -1);
  return omit(form, emptyKeys);
};
